import clsx from 'clsx';
import { Outlet } from 'react-router-dom';
import { useNetworkState } from 'react-use';
import { useAppContext } from 'src/contexts/AppContext';
import { CommandMenuContextProvider } from 'src/contexts/CommandMenuContext/CommandMenuContext';
import { MenuContextProvider } from 'src/contexts/MenuContext/MenuContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { Offline } from 'src/navigations/Routes/Offline';

import * as styles from './App.css';

export const AppContent = () => {
  const isOnline = useNetworkState();
  const { isDarkMode } = useSiteTheme();
  const { appContext } = useAppContext();
  return (
    <div
      className={clsx(styles.root, styles.contentContainer, {
        [styles.darkModeRoot]: isDarkMode,
      })}
    >
      <CommandMenuContextProvider>
        <MenuContextProvider>
          {appContext === undefined ? (
            isOnline ? (
              <div className={styles.spinnerContainer}>
                <PosSpinner />
              </div>
            ) : (
              <Offline />
            )
          ) : (
            <Outlet />
          )}
        </MenuContextProvider>
      </CommandMenuContextProvider>
    </div>
  );
};
